module.exports = __webpack_public_path__ + "static/media/tusla.73931526.png";